import React from 'react';
import { SearchInputProps } from '.';
import '../../../scss/vendors/bstyles.scss';
import './styles.scss';
import { ActionIcon, TextInput } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import ModalWrapper from '../ModalWrapper';

const SearchInput: React.FC<SearchInputProps> = ({
  leftIcon,
  rightIcon,
  placeholder,
  value,
  loading = false,
  onChange,
  onKeyPress,
  mdScreen,
  stylesInput,
  stylesContainer
}) => {
  const [opened, { toggle }] = useDisclosure(false);

  const handleToggle = () => {
    toggle();
  };

  if (mdScreen) {
    return (
      <>
        <ActionIcon
          variant="default"
          color={'dark'}
          size={'lg'}
          mr={8}
          radius={'md'}
          onClick={handleToggle}
        >
          {leftIcon}
        </ActionIcon>

        <ModalWrapper isVisible={opened} onClose={handleToggle} title="Search">
          <TextInput
            leftSection={leftIcon}
            label=""
            placeholder={placeholder || 'Search for anything'}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyPress}
            my={16}
          />
        </ModalWrapper>
      </>
    );
  }

  return (
    <div className="container-navigation" style={stylesContainer}>
      {leftIcon && <div className="left-icon">{leftIcon}</div>}
      {!mdScreen && (
        <div className="input-wrapper">
          <input
            className="input"
            placeholder={placeholder || 'Search for anything'}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyPress}
            style={stylesInput}
          />
        </div>
      )}
      {rightIcon && <div className="right-icon">{rightIcon}</div>}
      {loading && <div className="loading" />}
    </div>
  );
};

export default SearchInput;
